import $ from 'jquery'
import 'bootstrap'
import { Fancybox } from '@fancyapps/ui'
import imagesLoaded from 'imagesloaded'
import Cookies from 'js-cookie'
import Search from './Search'
import track from './track'

import './sass/index.sass'
import 'slick-carousel/slick/slick.css'
import attachSlick from 'slick-carousel'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

Fancybox.bind('.paragraph--type--images-grid a:not(.not-for-fancybox)', {
  // 20260126: 'animated' is no longer an option in v6
  // animated: false,
  groupAll: true,
})

attachSlick()

const instantiateSlick = (
  $el,
  numberOfSlides,
  numberOfSlidesMobile = numberOfSlides - 1,
  arrows = true
) => {
  if (
    $el.length === 0 ||
    $el.hasClass('instantiate-slick-was-already-called-on-this')
  ) {
    return
  }
  $el.addClass('instantiate-slick-was-already-called-on-this')
  $el.imagesLoaded().done(() => {
    if (numberOfSlidesMobile === 0) {
      numberOfSlidesMobile = 1
    }
    $el.slick({
      dots: true,
      infinite: false,
      slidesToScroll: numberOfSlidesMobile,
      slidesToShow: numberOfSlidesMobile,
      mobileFirst: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: arrows,
            slidesToScroll: numberOfSlides,
            slidesToShow: numberOfSlides,
          },
        },
      ],
    })
  })
}

const initNavbarShrink = () => {
  const shrinkScrollTop = 100
  const navbarExpandedHeight = 135
  const navbarShrunkenHeight = 75
  const brandExpandedWidth = 165
  const brandShrunkenWidth = 98
  const navbarShrinkAmount = navbarExpandedHeight - navbarShrunkenHeight
  const brandShrinkAmount = brandExpandedWidth - brandShrunkenWidth
  const mmExpandedTop = 70
  const mmExpandedTopPadding = 40
  const mmShrunkenTop = 46
  const mmShrunkenTopPadding = 20
  const mmTopShrinkAmount = mmExpandedTop - mmShrunkenTop
  const mmTopPaddingShrinkAmount = mmExpandedTopPadding - mmShrunkenTopPadding

  $(window).on('resize', function () {
    $(window).trigger('scroll')
  })
  $(window).on('scroll', function () {
    if ($(window).width() >= 992) {
      let windowScrollTop = $(this).scrollTop()
      let alertBarHeight = $('body').hasClass('has-open-site-alert')
        ? $('.jbc-site-alert').outerHeight()
        : 0
      if (windowScrollTop < shrinkScrollTop) {
        let shrinkPercentage = windowScrollTop / shrinkScrollTop
        let curNavHeight =
          navbarExpandedHeight - navbarShrinkAmount * shrinkPercentage
        let curBrandWidth =
          brandExpandedWidth - brandShrinkAmount * shrinkPercentage
        $('.navbar').outerHeight(curNavHeight)
        $('.navbar .brand').outerWidth(curBrandWidth)
        $('.navbar .brand .logotype').css('opacity', 1 - shrinkPercentage)
        $('.navbar').removeClass('navbar-shrunk')
        $('.search-container').css('top', curNavHeight + alertBarHeight - 1)
        $('.mega-menu')
          .css('top', mmExpandedTop - mmTopShrinkAmount * shrinkPercentage)
          .css(
            'padding-top',
            mmExpandedTopPadding - mmTopPaddingShrinkAmount * shrinkPercentage
          )
        $('.mega-menu-bg').css(
          'top',
          navbarExpandedHeight - navbarShrinkAmount * shrinkPercentage - 1
        )
      } else {
        $('.navbar').outerHeight(navbarShrunkenHeight)
        $('.navbar .brand').outerWidth(brandShrunkenWidth)
        $('.navbar .brand .logotype').css('opacity', 0)
        $('.navbar').addClass('navbar-shrunk')
        $('.search-container').css(
          'top',
          navbarShrunkenHeight + alertBarHeight - 1
        )
        $('.mega-menu')
          .css('top', mmShrunkenTop)
          .css('padding-top', mmShrunkenTopPadding)
        $('.mega-menu-bg').css('top', navbarShrunkenHeight - 1)
      }
    } else {
      $('.navbar').css('height', 'auto')
      $('.navbar .brand').css('width', '90px')
      $('.navbar .brand .logotype').css('opacity', '1')
      $('.navbar').removeClass('navbar-shrunk')
      if ($('body').hasClass('has-open-site-alert')) {
        $('.search-container').css('top', '121px')
      } else {
        $('.search-container').css('top', '65px')
      }
    }
  })
}

const scrollToAnchorWithNavOffset = (extraOffset = 0) => {
  const hash = window.location.hash.replace('#', '')
  const navbarShrunkenHeight = 75
  if (hash) {
    const $targetSection = $('[name=' + hash + ']')
    const $siteAlert = $('body > .jbc-site-alert')
    const offset =
      $siteAlert.length &&
      $siteAlert.find('.alert.bs-site-alert').is(':visible')
        ? navbarShrunkenHeight + $siteAlert.outerHeight()
        : navbarShrunkenHeight
    if ($targetSection.length) {
      // and scroll down to it.
      $([document.documentElement, document.body])
        .stop()
        .animate(
          {
            scrollTop: $targetSection.offset().top - offset - extraOffset,
          },
          500
        )
    }
  }
}

$(document).ready(() => {
  imagesLoaded.makeJQueryPlugin($)

  // gtag wrapper
  track()

  // Search
  new Search()

  // Site alert
  const $siteAlert = $('body > .jbc-site-alert')
  if (
    $siteAlert.length &&
    $siteAlert.find('.alert.bs-site-alert').is(':visible')
  ) {
    $('body').addClass('has-open-site-alert')
    $siteAlert.find('button.close').one('click', () => {
      $('body').removeClass('has-open-site-alert')
      $(window).scroll()
    })
  }

  // Main menu
  if ($('.navbar').length) {
    // Shrinking navbar
    initNavbarShrink()

    // Mega menus
    const $topLevelLi = $('.navbar-nav > ul.nav > li')
    $topLevelLi.on('mouseover', (event) => {
      if ($(window).width() >= 992) {
        if ($(event.currentTarget).find('.mega-menu').length) {
          $('body').addClass('mega-menu-open')
          $('.mega-menu-bg').show()
        }
        $(event.currentTarget).find('.mega-menu').show().addClass('is-open')
        $(event.currentTarget).addClass('active-sub-menu')
      }
    })

    $topLevelLi.on('mouseout', (event) => {
      $(event.currentTarget).find('.mega-menu').hide().removeClass('is-open')
      $('.mega-menu-bg').hide()
      $(event.currentTarget).removeClass('active-sub-menu')
      $('body').removeClass('mega-menu-open')
    })

    $topLevelLi.find('> a').on('focus', (event) => {
      if ($('body').hasClass('mega-menu-open')) {
        // If there is already a mega menu open, close it
        $('.active-sub-menu').removeClass('active-sub-menu')
        $('.mega-menu').hide().removeClass('is-open')
        $('.mega-menu-bg').hide()
        $('body').removeClass('mega-menu-open')
      }
      if ($(window).width() >= 992) {
        if ($(event.currentTarget).parent().find('.mega-menu').length) {
          $('body').addClass('mega-menu-open')
          $('.mega-menu-bg').show()
          $(event.currentTarget)
            .parent()
            .find('.mega-menu')
            .show()
            .addClass('is-open')
          $(event.currentTarget).parent().addClass('active-sub-menu')
        }
      }
    })
  }

  // instantiateSlick($el, numberOfSlides, numberOfSlidesMobile = numberOfSlides - 1, arrows = true)

  // Awards -> Latest NJBA Winners
  instantiateSlick(
    $('.view-id-njba_awardees.view-display-id-latest_awardees .view-content'),
    5,
    3
  )

  // Awards -> Natan Notable Books Recent Selections
  instantiateSlick(
    $(
      '.page-node-type-awards-page .field--name-field-recent-selections > .field__items'
    ),
    5,
    3
  )

  // Books -> New Reviews
  instantiateSlick(
    $(
      '.view-id-books.view-display-id-new_reviews_for_books_page .view-content'
    ),
    3,
    3
  )

  // Books -> Natan
  instantiateSlick(
    $(
      '.page-node-type-natan-notable-books-page .paragraph--type--slider .field__items'
    ),
    3,
    1
  )

  // Book Clubs -> JBC Discussion Guides
  instantiateSlick(
    $('.view-id-books.view-display-id-jbc_discussion_guides .view-content'),
    4
  )

  // Book Clubs -> Discussion Questions
  instantiateSlick(
    $('.view-id-books.view-display-id-discussion_questions .view-content'),
    4
  )

  // Book Clubs -> New in Paperback
  instantiateSlick($('.field--name-field-new-in-paperback > .field__items'), 4)

  // Paper Brigade -> Past Issues
  instantiateSlick(
    $(
      '.view-id-paper_brigade_issues.view-display-id-past_issues .view-content'
    ),
    2
  )

  // Paper Brigade -> Reader Photos
  instantiateSlick($('.field--name-field-reader-photos'), 4)

  // Support
  instantiateSlick(
    $('.page-node-type-support-page .field--name-field-slideshow'),
    1,
    1,
    false
  )

  // History paragraph--type--paragraph-images
  instantiateSlick(
    $('.page-node-type-history-page .field--name-field-images-p'),
    1,
    1,
    false
  )

  // Featured Reading Lists
  instantiateSlick($('.field--name-field-featured-reading-lists'), 1, 1)

  // Any Slider chunk
  instantiateSlick($('.paragraph--type--slider .field__items'), 3)

  // Any Slideshow chunk
  instantiateSlick($('.paragraph--type--slideshow .field__items'), 1)

  // Any Slideshow field
  instantiateSlick($('.field--name-field-slideshow'), 1)

  // Any Images field
  instantiateSlick($('.field--name-field-images'), 1)

  // Affiliate links dropdown
  const $affiliateLinks = $('.affiliate-links')
  $affiliateLinks.find('button').on('click', () => {
    if ($affiliateLinks.hasClass('is-open')) {
      $affiliateLinks.removeClass('is-open')
    } else {
      $affiliateLinks.addClass('is-open')
    }
  })

  // Content tabs
  const $tabContent = $('.tabs-tab-content .tab-content')
  const $tabLinks = $('.tabs-tab-content .tabs')
  $tabLinks.find('a').on('click', (event) => {
    const slug = $(event.target).attr('href').replace(/#/g, '')
    $tabLinks.find('a').removeClass('is-active')
    $tabLinks.find(`a[href$="${slug}"]`).addClass('is-active')
    $tabContent.removeClass('is-visible')
    const $thisTabContent = $(`.tab-content.${slug}`)
    $thisTabContent.addClass('is-visible')
    $thisTabContent.find('.pager__items a').each((i, el) => {
      const hrefWithHash = `${$(el).attr('href')}#${slug}`
      $(el).attr('href', hrefWithHash)
    })
  })
  // If we've got a tab content slug in the URL,
  const slug = window.location.hash.replace('#', '')
  if (slug) {
    const $possibleSectionToOpen = $(`.tab-content.${slug}`)
    const headerHeight =
      $('.navbar').outerHeight() +
      $('.jbc-site-alert').outerHeight() +
      $('.tabs-tab-content ul.tabs').outerHeight()
    if ($possibleSectionToOpen.length) {
      // make its menu item active
      $tabLinks.find('a').removeClass('is-active')
      $tabLinks.find(`a[href$="${slug}"]`).addClass('is-active')
      // make it visible
      $tabContent.removeClass('is-visible')
      $possibleSectionToOpen.addClass('is-visible')
      // and scroll down to it.
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $possibleSectionToOpen.offset().top - headerHeight,
        },
        500
      )
      $possibleSectionToOpen.find('.pager__items a').each((i, el) => {
        const hrefWithHash = `${$(el).attr('href')}#${slug}`
        $(el).attr('href', hrefWithHash)
      })
    }
  }

  // FAQs
  $('.paragraph--type--faq .field--name-field-question').on(
    'click',
    (event) => {
      const $parent = $(event.target).parents('.paragraph--type--faq')
      // Is the FAQ currently open?
      if ($parent.hasClass('is-open')) {
        // Yep, close it
        $parent.removeClass('is-open')
      } else {
        // Nope, open it
        $parent.addClass('is-open')
      }
    }
  )

  // Expandable Sections (maybe merge this with FAQs at some point)
  $('.paragraph--type--expandable-section .field--name-field-title').on(
    'click',
    (event) => {
      const $parent = $(event.target).parents(
        '.paragraph--type--expandable-section'
      )
      if ($parent.hasClass('is-open')) {
        $parent.removeClass('is-open')
      } else {
        $parent.addClass('is-open')
      }
    }
  )

  // Book Search
  $('.container-book-search .filters-toggle').on('click', () => {
    $('.books-search-form').toggleClass('is-open')
  })

  // Israel Bookshelf sign up form revealer and hider
  const $israelBookshelfSignUpForm = $(
    '.page-node-type-israel-bookshelf-page .field--name-field-form'
  )
  const $israelBookshelfSignUpButton = $(
    '.page-node-type-israel-bookshelf-page .sign-up-button button'
  )
  const $israelBookshelfCancelButton =
    $israelBookshelfSignUpForm.find('#edit-cancel a.btn')
  $israelBookshelfSignUpButton.on('click', () => {
    $israelBookshelfSignUpForm.addClass('is-open')
    $israelBookshelfSignUpButton.hide()
  })
  $israelBookshelfCancelButton.on('click', (event) => {
    event.preventDefault()
    $israelBookshelfSignUpForm.removeClass('is-open')
    $israelBookshelfSignUpForm
      .find('input[type="checkbox"]')
      .prop('checked', false)
    $israelBookshelfSignUpForm
      .find('input[type="radio"]')
      .prop('checked', false)
    $israelBookshelfSignUpForm.find('input[type="text"]').val('')
    $israelBookshelfSignUpButton.show()
    $('html, body').animate(
      {
        scrollTop: $israelBookshelfSignUpButton.offset().top - 400,
      },
      500
    )
  })

  // JBC Authors Subpages registration sections
  if ($('.paragraph--type--registration-section').length) {
    // If we've got a registration section slug in the URL,
    const slug = window.location.hash.replace('#', '')
    const $possibleSectionToOpen = $(`.paragraph--slug--${slug}`)
    const headerHeight =
      $('.navbar').outerHeight() + $('.jbc-site-alert').outerHeight()
    if ($possibleSectionToOpen.length) {
      // open it up
      $possibleSectionToOpen.addClass('is-open')
      // and scroll down to it.
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $possibleSectionToOpen.offset().top - headerHeight,
        },
        500
      )
    }
    // Handle clicks on registration section titles
    $('.paragraph--type--registration-section h2').on('click', (event) => {
      const $parent = $(event.target).parents(
        '.paragraph--type--registration-section'
      )
      // Is the section currently open?
      if ($parent.hasClass('is-open')) {
        // Yep, close it
        $parent.removeClass('is-open')
      } else {
        // Nope, open it
        $parent.addClass('is-open')
      }
    })
  }

  // Newsletter signup
  $(".newsletter-signup-form input[name='email_address']").on(
    'keydown',
    (event) => {
      $(event.target).parent().find('.invalid-feedback').hide()
    }
  )
  $('.newsletter-signup-form').on('submit', (event) => {
    event.preventDefault()
    const $form = $(event.target)
    const emailAddress = $form.find("input[name='email_address']").val()
    if (emailAddress === '') {
      $form.find('.invalid-feedback').show()
    } else {
      $.ajax({
        data: {
          email_address: emailAddress,
        },
        type: 'post',
        url: drupalSettings.jbcSettings.apiSubscribeUrl,
      }).always(() => {
        $form.find('.input-group').hide()
        $form.find('input').hide()
        $form.append('<div class="newsletter-signup-success">Thanks!</div>')
      })
    }
  })

  // Support
  if ($('form#donation').length) {
    scrollToAnchorWithNavOffset(-120)
  }

  // Remove non-breaking space char after smart double quote
  $('body :not(script)')
    .contents()
    .filter((i, el) => el.nodeType === 3)
    .replaceWith(function replacer() {
      return this.nodeValue.replace('“\u00a0', '“')
    })

  $('.buy-now-button button').on('click', (event) => {
    const $buyNowButtonActualPaymentLinks = $(event.target).parents(
      '.buy-now-button-actual-payment-links'
    )
    if ($buyNowButtonActualPaymentLinks.hasClass('is-open')) {
      $buyNowButtonActualPaymentLinks.removeClass('is-open')
    } else {
      $buyNowButtonActualPaymentLinks.addClass('is-open')
    }
  })

  // All JBC Authors fake radios
  const $fakeRadios = $('.all-jbc-authors-title-radios-exposed')
  if ($fakeRadios.length) {
    $fakeRadios
      .find('input[name="jbc-network-or-read-on"]')
      .on('change', (event) => {
        if (event.target.value === 'network') {
          window.location.href = '/jbc-authors/all/network/current'
        } else {
          window.location.href = '/jbc-authors/all/read-on'
        }
      })
    $fakeRadios.find('input[name="current-or-past"]').on('change', (event) => {
      if (event.target.value === 'current') {
        window.location.href = '/jbc-authors/all/network/current'
      } else {
        window.location.href = '/jbc-authors/all/network/past'
      }
    })
  }

  // Account menu on Member Site Resources pages
  $('.block-accountmenu h2').on('click', (event) => {
    if ($(event.target).parent().hasClass('is-open')) {
      $(event.target).parent().removeClass('is-open')
    } else {
      $(event.target).parent().addClass('is-open')
    }
  })

  // NJBA Past Winners, NJBA Past Keynotes
  const $njbaAwardeesPastWinnersAndPastKeynotes = $(
    '.njba-awardees-past-winners'
  ).add('.njba-keynotes-past-keynotes')
  if ($njbaAwardeesPastWinnersAndPastKeynotes.length) {
    // Decade accordion
    $njbaAwardeesPastWinnersAndPastKeynotes
      .find('.decade > button')
      .on('click', (event) => {
        const $clicked = $(event.target)
        const $clickedYearsLi = $clicked.parent()
        $clickedYearsLi.addClass('is-open')
        const $otherYearsLis =
          $njbaAwardeesPastWinnersAndPastKeynotes.find('.decade')
        $otherYearsLis.not($clickedYearsLi).removeClass('is-open')
      })
    // Show Past Categories button
    $njbaAwardeesPastWinnersAndPastKeynotes
      .find('.past-categories > button')
      .on('click', () => {
        $njbaAwardeesPastWinnersAndPastKeynotes
          .find('.past-categories')
          .addClass('is-open')
      })
    // Decades / Categories toggle
    $njbaAwardeesPastWinnersAndPastKeynotes
      .find('.by-year-or-by-category > h2')
      .on('click', (event) => {
        const $parent = $(event.target).parent()
        if ($(window).width() < 992) {
          $parent.toggleClass('is-open')
        } else if (!$parent.hasClass('is-default-open')) {
          $parent.toggleClass('is-open')
        } else {
          $parent.removeClass('is-default-open')
        }
      })
  }

  // Announcement modal
  if (
    drupalSettings.jbcSettings.announcementKey !== undefined &&
    drupalSettings.jbcSettings.announcementKey !== ''
  ) {
    const announcementKeyComponents =
      drupalSettings.jbcSettings.announcementKey.split('_')
    const nid = announcementKeyComponents[0]
    const time = parseInt(announcementKeyComponents[1], 10)
    const visitorJakStr = Cookies.get('Drupal.visitor.jak')
    const visitorJak = visitorJakStr ? JSON.parse(visitorJakStr) : {}
    const close = () => {
      visitorJak[nid] = time
      Cookies.set('Drupal.visitor.jak', JSON.stringify(visitorJak), {
        expires: 365,
        path: drupalSettings.path.baseUrl,
      })
      $('.announcement-modal').removeClass('is-visible')
      $('.announcement-modal-content article').off('click')
    }
    if (visitorJak[nid] === undefined || visitorJak[nid] < time) {
      $('.announcement-modal')
        .addClass('is-visible')
        .one('click', () => {
          close()
        })
      $('.announcement-modal-content article').on('click', (event) => {
        event.stopPropagation()
      })
      $('.announcement-modal-content article')
        .find('button')
        .one('click', () => {
          close()
        })
    }
  }

  const handleKeydown = (event) => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault()
      $(event.target).trigger('click')
    }
  }
  $('button.dropdown-toggle').on('keydown', handleKeydown)
  $('.keydown-to-click').on('keydown', handleKeydown)
})
